<template>
  <BaseDetailLayout :title="`${customerAddressModule.customerAddress} Details`">
    <template #detail>
      <v-row class="ma-0">
        <v-col cols="12" lg="3" class="pr-1">
          <section class="d-flex flex-column h-100">
            <v-card elevation="0" class="mb-3 rounded-lg">
              <v-row no-gutters class="pa-4">
                <v-col cols="12">
                  <v-row no-gutters>
                    <v-col cols="12" class="d-flex justify-space-between">
                      <h4
                        class="text_color--text"
                        v-if="
                          customerAddressDetails &&
                          customerAddressDetails.location_id
                        "
                      >
                        {{ customerAddressDetails.location_id }}
                      </h4>
                      <v-tooltip
                        bottom
                        max-width="150"
                        color="red"
                        z-index="12"
                        v-if="
                          customerAddressDetails.warning &&
                          Object.keys(customerAddressDetails.warning).length > 0
                        "
                      >
                        <template #activator="{ on, attrs }">
                          <v-icon
                            color="error"
                            class="mr-2"
                            v-on="on"
                            v-bind="attrs"
                          >
                            mdi-alert-circle
                          </v-icon>
                        </template>
                        <div>
                          <span class="font-weight-bold">
                            {{ customerAddressDetails.warning.message }}
                          </span>
                        </div>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="12" class="pt-3">
                      <BaseLabel
                        v-if="customerAddressDetails.customer_name"
                        icon="mdi-account"
                        :text="customerAddressDetails.customer_name"
                        :label="`${customerModule.customer} Name`"
                        :tooltipLabel="`${customerModule.customer} Name`"
                        textClass="pl-0"
                      />
                    </v-col>
                    <v-col cols="6">
                      <BaseLabel
                        v-if="
                          customerAddressDetails &&
                          customerAddressDetails.processing_time
                        "
                        icon="mdi-timer-lock"
                        :text="customerAddressDetails.processing_time"
                        label="Processing Time"
                        tooltipLabel="Processing Time"
                        textClass="pl-0"
                      />
                    </v-col>
                    <v-col cols="6">
                      <BaseLabel
                        v-if="
                          customerAddressDetails &&
                          customerAddressDetails.from_time &&
                          customerAddressDetails.to_time
                        "
                        icon="mdi-account"
                        :text="`${customerAddressDetails.from_time} - ${customerAddressDetails.to_time}`"
                        label="Delivery Window"
                        tooltipLabel="Delivery Window"
                        textClass="pl-0"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
            <v-card elevation="0" class="mb-3 h-100 rounded-lg">
              <v-card-title class="px-3 py-1">
                <v-row no-gutters>
                  <v-col cols="12">
                    <h6>{{ customerAddressModule.customerAddress }} Details</h6>
                  </v-col>
                  <!-- <v-col cols="6" class="text-right">
                    <v-icon
                      class="primary--text"
                      v-if="permissions.change"
                      @click="showCustomerForm = true"
                      small
                      >mdi-pencil</v-icon
                    >
                  </v-col> -->
                </v-row>
              </v-card-title>
              <v-divider></v-divider>

              <v-card-subtitle>
                <div
                  v-if="customerAddressDetails"
                  class="overflow-y-auto"
                  style="max-height: 400px"
                >
                  <div
                    v-for="(value, key, index) in customerAddressDetails"
                    :key="index"
                  >
                    <v-row
                      no-gutters
                      class="pt-1 px-2"
                      v-if="
                        ![
                          'id',
                          'location_id',
                          'warning',
                          'customer',
                          'latitude',
                          'processing_time',
                          'from_time',
                          'to_time',
                          'longitude',
                          'order_statistics',
                          'coordinates',
                        ].includes(key) && value
                      "
                    >
                      <v-col cols="5" v-if="key">
                        <h5 class="text_color--text text-capitalize">
                          {{ key.replace(/_/g, " ") }}
                        </h5>
                      </v-col>
                      <v-col cols="7">
                        <h5
                          v-if="
                            key == 'email_notification' ||
                            key == 'whatsapp_notification'
                          "
                        >
                          <v-icon small :color="value ? 'success' : 'error'">
                            {{
                              value ? "mdi-check-circle" : "mdi-close-circle"
                            }}
                          </v-icon>
                        </h5>
                        <h5 v-else>{{ value }}</h5>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-card-subtitle>
            </v-card>

            <v-card elevation="0" class="rounded-lg">
              <v-card-title class="px-3 py-1">
                <v-row no-gutters>
                  <v-col cols="6">
                    <h6>Assigned {{ tripPlanningModule.tagPlural }}</h6>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <v-icon
                      @click="openAssignedTagFormDialog = true"
                      class="primary--text"
                      >mdi-plus</v-icon
                    >
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider></v-divider>

              <div
                v-if="
                  customerAddressTagList && customerAddressTagList.length > 0
                "
                class="px-4 py-2 overflow-y-auto"
                style="height: 110px"
              >
                <v-chip-group column>
                  <v-chip
                    small
                    close
                    close-icon="mdi-close"
                    v-for="(tag, index) in customerAddressTagList"
                    :key="index"
                    @click:close="deleteCustomerAddressTag(tag.id, index)"
                    >{{ tag.tag }}</v-chip
                  >
                </v-chip-group>
              </div>
              <v-card-subtitle
                v-else
                style="height: 110px"
                class="d-flex justify-center align-center"
              >
                <h5 class="font-weight-bold text_color--text">
                  There is no tag assigned.
                </h5>
              </v-card-subtitle>
            </v-card>
          </section>
        </v-col>
        <v-col cols="12" lg="6" class="px-2">
          <section>
            <div
              v-if="
                customerAddressDetails &&
                customerAddressDetails.order_statistics
              "
              class="pb-2"
            >
              <v-row no-gutters>
                <v-col
                  class="pb-1"
                  v-for="(
                    value, key, index
                  ) in customerAddressDetails.order_statistics"
                  :key="index"
                  :class="
                    Object.keys(customerAddressDetails.order_statistics)
                      .length -
                      1 ==
                    index
                      ? ''
                      : 'pr-2'
                  "
                >
                  <v-card elevation="0" class="rounded-lg">
                    <v-card-text class="px-4 py-2">
                      <span
                        class="text_color--text text-capitalize text-center text-caption font-weight-bold d-flex justify-center"
                        v-if="key == 'orders_in_last_days'"
                      >
                        orders in last 7 days
                      </span>
                      <span
                        v-else
                        class="text_color--text text-capitalize text-center text-caption font-weight-bold d-flex justify-center"
                      >
                        {{ key.replace(/_/g, " ") }}
                      </span>

                      <div
                        class="mt-2 d-flex align-center justify-space-around"
                      >
                        <v-icon :color="customerAnalyticsColor[key]">
                          {{ customerAnalyticsIcon[key] }}</v-icon
                        >

                        <span class="text-caption">
                          <h3>{{ value }}</h3>
                        </span>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
            <div>
              <v-card
                elevation="0"
                v-if="!isVisibleOrderDetails"
                class="rounded-lg"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-tabs v-model="tab" right class="rounded-lg">
                      <v-tab class="rounded-lg">
                        <h4
                          class="text-caption font-weight-bold app-driver-font-tab"
                        >
                          Today
                        </h4>
                      </v-tab>

                      <v-tab>
                        <h4
                          class="text-caption font-weight-bold app-driver-font-tab"
                        >
                          last 7 days
                        </h4>
                      </v-tab>
                      <v-tab>
                        <h4
                          class="text-caption font-weight-bold app-driver-font-tab"
                        >
                          Next 7 days
                        </h4>
                      </v-tab>
                    </v-tabs>
                  </v-col>
                  <v-col cols="12" style="height: calc(100vh - 345px)">
                    <AgGridVue
                      @grid-ready="gridReady"
                      :grid-options="gridOptions"
                      :column-defs="tableHeader"
                      :default-col-def="defaultColDef"
                      :row-data="orderList"
                      :context="context"
                      style="width: 100%; height: calc(100vh - 345px)"
                      class="ag-theme-balham px-4 pt-4"
                    >
                    </AgGridVue>
                  </v-col>
                  <v-col cols="12" class="d-flex justify-end">
                    <Pagination
                      :pageNo="pageNo"
                      :totalItems="totalCount"
                      :pageSize="itemsPerPage"
                      @itemsPerPageChange="itemsPerPageChange"
                      @prevPage="prevPage"
                      @nextPage="nextPage"
                    />
                  </v-col>
                </v-row>
              </v-card>
              <v-card elevation="0" v-else style="height: calc(100vh - 240px)">
                <v-row no-gutters>
                  <v-col cols="6" class="d-flex align-center pl-2">
                    <v-icon
                      small
                      @click="isVisibleOrderDetails = false"
                      class="mx-3"
                      >mdi-arrow-left</v-icon
                    >
                    <h4 class="text-capitalize text-subtitle-2">
                      {{ orderModule.order }} details
                    </h4>
                  </v-col>
                  <v-col cols="6">
                    <v-tabs v-model="tabDetails" right class="rounded-lg">
                      <v-tab>
                        <h4
                          class="text-caption font-weight-bold app-driver-font-tab"
                        >
                          Details
                        </h4>
                      </v-tab>

                      <v-tab>
                        <h4
                          class="text-caption font-weight-bold app-driver-font-tab"
                        >
                          Logs
                        </h4>
                      </v-tab>
                    </v-tabs>
                  </v-col>
                  <v-col cols="12" class="pa-0 mx-0 background_color">
                    <v-tabs-items v-model="tabDetails" class="">
                      <v-tab-item
                        class="background_color"
                        style="height: calc(100vh - 300px)"
                      >
                        <v-card elevation="0" class="pa-0 rounded-lg mb-6">
                          <v-row
                            class="px-3"
                            v-if="orderDetail && orderDetail.order_details"
                          >
                            <v-col cols="6" class="d-flex align-center">
                              <h2
                                class="mr-2"
                                v-if="orderDetail.reference_number"
                              >
                                {{ orderDetail.reference_number }}
                              </h2>
                              <v-chip
                                class="mr-1 text-capitalize font-weight-bold"
                                x-small
                                v-if="orderDetail.verbose_status"
                                :class="
                                  $helper.getOrderStatusColor(
                                    orderDetail.verbose_status,
                                    true
                                  )
                                "
                              >
                                {{ orderDetail.verbose_status }}
                              </v-chip>
                            </v-col>
                            <v-col
                              cols="6"
                              class="text-right d-flex justify-end"
                              v-if="orderDetail.branch"
                            >
                              <div class="mr-2">
                                <TripTooltipWithIcon
                                  icon="mdi-package-variant-closed"
                                  :text="orderDetail.branch"
                                  :label="`${configurationModule.branch} Name`"
                                />
                              </div>
                              <div
                                class="mr-2"
                                v-if="orderDetail.execution_date"
                              >
                                <TripTooltipWithIcon
                                  icon="mdi-calendar-range"
                                  :text="orderDetail.execution_date"
                                  :label="`${tripModule.trip} Date`"
                                />
                              </div>
                            </v-col>
                          </v-row>
                        </v-card>

                        <v-card elevation="0" class="rounded-lg pa-0 mb-3">
                          <v-row
                            class="px-3 py-2"
                            no-gutters
                            v-if="orderDetail.customer_details"
                          >
                            <v-col
                              cols="3"
                              class="pb-1 hover-pointe"
                              v-if="
                                orderDetail.customer_details &&
                                orderDetail.customer_details.customer_name
                              "
                              @click="
                                redirectCustomerDetails(
                                  orderDetail.customer_details
                                )
                              "
                            >
                              <TripTooltipWithIcon
                                icon="mdi-account"
                                :text="
                                  orderDetail.customer_details.customer_name
                                "
                                :label="`${customerModule.customer} Name`"
                              />
                            </v-col>
                            <v-col
                              cols="3"
                              class="pb-1 hover-pointe"
                              v-if="
                                orderDetail.customer_details &&
                                orderDetail.customer_details.customer_number
                              "
                              @click="
                                redirectCustomerDetails(
                                  orderDetail.customer_details
                                )
                              "
                            >
                              <TripTooltipWithIcon
                                icon="mdi-phone"
                                :text="
                                  orderDetail.customer_details.customer_number
                                "
                                :label="`${customerModule.customer} number`"
                              />
                            </v-col>

                            <v-col
                              cols="3"
                              class="pb-1 hover-pointe"
                              v-if="
                                orderDetail.customer_details &&
                                orderDetail.customer_details.contact_person
                              "
                              @click="
                                redirectCustomerDetails(
                                  orderDetail.customer_details
                                )
                              "
                            >
                              <TripTooltipWithIcon
                                icon="mdi-account-card"
                                :text="
                                  orderDetail.customer_details.contact_person
                                "
                                label="contact person"
                              />
                            </v-col>
                            <v-col
                              cols="3"
                              class="pb-1 hover-pointe"
                              v-if="
                                orderDetail.customer_details &&
                                orderDetail.customer_details.contact_email
                              "
                              @click="
                                redirectCustomerDetails(
                                  orderDetail.customer_details
                                )
                              "
                            >
                              <TripTooltipWithIcon
                                icon="mdi-email"
                                :text="
                                  orderDetail.customer_details.contact_email
                                "
                                :label="`${customerModule.customer} email`"
                              />
                            </v-col>
                            <v-col
                              cols="3"
                              class="pb-1 hover-pointe"
                              v-if="
                                orderDetail.customer_details &&
                                orderDetail.customer_details.from_time
                              "
                            >
                              <TripTooltipWithIcon
                                icon="mdi-clock-time-five-outline"
                                :text="orderDetail.customer_details.from_time"
                                :label="`${customerModule.customer} from time`"
                              />
                            </v-col>
                            <v-col
                              cols="3"
                              class="pb-1"
                              v-if="
                                orderDetail.customer_details &&
                                orderDetail.customer_details.to_time
                              "
                            >
                              <TripTooltipWithIcon
                                icon="mdi-clock-time-four"
                                :text="orderDetail.customer_details.to_time"
                                :label="`${customerModule.customer} to time`"
                              />
                            </v-col>

                            <v-col
                              cols="3"
                              class="pb-1"
                              v-if="
                                orderDetail.order_details &&
                                orderDetail.order_details.weight
                              "
                            >
                              <TripTooltipWithIcon
                                icon="mdi-weight"
                                :text="orderDetail.order_details.weight"
                                :label="`${orderModule.order} weight`"
                              />
                            </v-col>
                            <v-col
                              cols="3"
                              class="pb-1"
                              v-if="
                                orderDetail.order_details &&
                                orderDetail.order_details.volume
                              "
                            >
                              <TripTooltipWithIcon
                                icon="mdi-cube"
                                :text="orderDetail.order_details.volume"
                                :label="`${orderModule.order} volume`"
                              />
                            </v-col>
                            <v-col
                              cols="3"
                              class="pb-1"
                              v-if="
                                orderDetail.order_details &&
                                orderDetail.order_details.total_items
                              "
                            >
                              <TripTooltipWithIcon
                                icon="mdi-information"
                                :text="orderDetail.order_details.total_items"
                                :label="`${orderModule.order} items`"
                              />
                            </v-col>
                            <v-col
                              cols="3"
                              class="pb-1"
                              v-if="
                                orderDetail.order_details &&
                                orderDetail.order_details.total_quantity
                              "
                            >
                              <TripTooltipWithIcon
                                icon="mdi-archive"
                                :text="orderDetail.order_details.total_quantity"
                                :label="`${orderModule.order} total quantity`"
                              />
                            </v-col>
                          </v-row>
                        </v-card>

                        <v-card
                          elevation="0"
                          class="h-100 rounded-lg pa-2"
                          v-if="$helper.isCompanyHasItems()"
                        >
                          <OrderItems
                            :orderId="orderDetail.id"
                            :status="orderDetail.status"
                          />
                        </v-card>
                      </v-tab-item>

                      <v-tab-item>
                        <Logs :logs="orderLogs" />
                      </v-tab-item>
                    </v-tabs-items>
                  </v-col>
                </v-row>
              </v-card>
            </div>
            <!-- <div>3</div> -->
          </section>
        </v-col>
        <v-col cols="12" lg="3" class="pl-1">
          <v-card class="rounded-lg pa-2" elevation="0">
            <GoogleMap
              :hasMapInfo="true"
              id="customerLocation"
              mapHeight="270px"
              ref="customerLocation"
              :clusterMarkers="true"
            >
              <template #mapInfo>
                <MapInfo legendType="customer_address_location" />
              </template>
            </GoogleMap>
          </v-card>

          <v-card class="rounded-lg mt-3" elevation="0">
            <v-card-title class="px-3 py-1">
              <v-row no-gutters>
                <v-col cols="6">
                  <h6>Logs</h6>
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text
              class="overflow-y-auto"
              style="height: calc(100vh - 500px)"
            >
              <Logs :logs="customerLogs" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template #dialog>
      <CustomerAddressForm
        v-model="showCustomerAddressFormDialog"
        :editMode="isEditing"
        :customerAddressId="selectedCustomerAddressID"
        :customerParentObj="customerAddressDetails"
        @refreshList="
          checkSubscriptionLimit();
          getCustomerAddressDetails();
        "
      />

      <BaseDialog
        :title="`${customerAddressModule.customerAddress} Logs`"
        v-model="showCustomerAddressLogs"
        @reset="showCustomerAddressLogs = false"
      >
        <template #information>
          <Logs :logs="customerAddressLogs"></Logs>
        </template>
      </BaseDialog>

      <TagListForm
        v-model="openAssignedTagFormDialog"
        :parentObj="customerAddressDetails"
        tagType="Customer Address"
        @refresh="getCustomerAddressTagList"
      />
      <CustomerAddressLocation
        ref="CustomerAddressLocation"
        v-model="openCustomerAddressMapDialog"
      />
    </template>
  </BaseDetailLayout>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { bus } from "@/main.js";
import { AgGridVue } from "ag-grid-vue";
import Pagination from "@/components/BaseComponents/Pagination.vue";
import BaseDetailLayout from "@/components/LayoutComponents/BaseDetailLayout.vue";
import DialogBase from "@/components/BaseComponents/DialogBase.vue";
import Logs from "@/components/BaseComponents/Logs.vue";
import BaseSmallTripDetail from "@/components/BaseComponents/BaseSmallTripDetail.vue";
import driverImage from "@/assets/profile.jpg";
import OrderTooltipWithIcon from "@/components/ModuleBasedComponents/Order/OrderTooltipWithIcon.vue";
import CustomerOrderDetailsButton from "@/components/Button/CustomerOrderDetailsButton.vue";
import OrderItems from "@/components/ModuleBasedComponents/Order/OrderItems.vue";
import TripTooltipWithIcon from "@/components/ModuleBasedComponents/Trip/TripTooltipWithIcon.vue";
import GoogleMap from "@/components/BaseComponents/GoogleMap.vue";
import MapInfo from "@/components/BaseComponents/MapInfo.vue";

import {
  configurationModule,
  customerModule,
  orderModule,
  tripModule,
  tripPlanningModule,
  customerAddressModule,
} from "@/utils/moduleMapping";
import { getDateTime, returnToday } from "@/utils/functions";
import CustomerForm from "@/components/ModuleBasedComponents/Customer/CustomerForm.vue";
import CustomerAddressButton from "@/components/Button/CustomerAddressButton.vue";
import CustomerAddressForm from "@/components/ModuleBasedComponents/CustomerAddress/CustomerAddressForm.vue";
import TagListForm from "@/components/GeneralComponents/TagListForm.vue";
import CustomerAddressLocation from "@/components/ModuleBasedComponents/CustomerAddress/CustomerAddressLocation.vue";
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import BaseLabel from "@/components/BaseComponents/BaseLabel.vue";

export default {
  components: {
    GoogleMap,
    MapInfo,
    Pagination,
    DialogBase,
    Logs,
    BaseSmallTripDetail,
    OrderTooltipWithIcon,
    AgGridVue,
    CustomerOrderDetailsButton,
    OrderItems,
    TripTooltipWithIcon,
    BaseDetailLayout,
    CustomerForm,
    CustomerAddressButton,
    CustomerAddressForm,
    TagListForm,
    CustomerAddressLocation,
    BaseDialog,
    BaseLabel,
  },
  data() {
    return {
      customerAddressModule,
      tripPlanningModule,
      configurationModule,
      orderModule,
      tripModule,
      customerModule,
      driverImage,
      tab: 0,
      showCustomerForm: false,
      tabDetails: 0,
      addressTab: 0,
      customerAnalyticsColor: {
        total_orders: "on_hold",
        orders_till_date: "green",
        orders_in_last_seven_days: "failed",
      },
      customerAnalyticsIcon: {
        total_orders: "mdi-archive",
        orders_till_date: "mdi-map-marker",
        orders_in_last_seven_days: "mdi-archive-clock",
      },

      showMore: false,
      driverDocuments: [],
      itemsPerPage: 10,
      pageNo: 1,
      addressTab: 0,
      defaultColDef: {
        lockPosition: true,
        flex: 1,
        resizable: true,
        sortable: true,
        autoHeight: true,
        cellStyle: {
          "text-overflow": "ellipsis",
          "white-space": "nowrap",
          overflow: "hidden",
          display: "block",
        },
      },
      gridOptions: {
        onGridSizeChanged: () => {
          this.autoSizeAll();
        },
        headerHeight: 40,
        rowHeight: 40,
        rowSelection: "multiple",
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
      },

      customerLogs: [],
      orderLogs: [],
      customerAddressDetails: {},
      isDriverLogsScrollable: true,
      driverZoneLogs: [],

      showDocumentDialog: false,
      customerLogsTotalCount: 0,
      isDriverZoneLogsScrollable: true,
      totalCount: 0,
      documentUploadFormDialog: false,
      orderList: [],
      customerAddressList: [],
      orderColumnDefs: [
        {
          headerName: "reference number",
          headerTooltip: "Reference Number",
          field: "reference_number",
          pinned: "left",
          minWidth: 200,
        },
        {
          headerName: "Execution Date",
          field: "execution_date",
          cellClass: "text-capitalize",
        },
        {
          headerName: "order status",
          field: "verbose_status",
          cellClass: "text-capitalize",
        },
        {
          headerName: "Order Type",
          field: "order_type",
          cellClass: "text-capitalize",
        },

        {
          headerName: "Volume",
          field: "volume",
          cellClass: "text-capitalize",
        },
        {
          headerName: "Weight",
          field: "weight",
          cellClass: "text-capitalize",
        },
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          width: 100,
          sortable: false,
          cellRenderer: "CustomerOrderDetailsButton",
        },
      ],
      customerAddressColumnDefs: [
        {
          headerName: "Location ID",
          field: "location_id",
          sortable: true,
        },
        {
          headerName: "Contact Person",
          field: "contact_person",
          sortable: true,
        },
        {
          headerName: "Contact Number",
          field: "contact_number",
          sortable: true,
        },
        {
          headerName: "Contact Email",
          field: "contact_email",
          sortable: true,
        },
        {
          headerName: "Address",
          field: "address",
          tooltipField: "address",
        },
        {
          headerName: "Address Info",
          field: "address_info",
        },
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          minWidth: 200,
          width: 200,
          sortable: false,
          resizable: false,
          cellRenderer: "CustomerAddressButton",
        },
      ],
      permissions: null,
      orderDetail: {},
      isVisibleOrderDetails: false,

      showCustomerAddressFormDialog: false,
      isEditing: false,
      selectedCustomerAddressID: null,

      showCustomerAddressLogs: false,
      customerAddressLogs: [],
      customerAddressTagList: [],
      customerDetailsMapInfo: {},

      openAssignedTagFormDialog: false,

      showDownloadSheetDialog: false,

      isButtonDisabled: false,
      openCustomerAddressMapDialog: false,
      buttonTooltip: "Add Customer Addresses",
      orderFilter: {
        execution_date: returnToday(),
      },
    };
  },
  watch: {
    tabDetails(val) {
      if (val == 1) {
        this.getOrderLogs();
      }
    },
    tab(val) {
      if (val == 0) {
        this.orderFilter = {
          execution_date: returnToday(),
        };
        this.getOrderList();
      } else if (val == 1) {
        this.orderFilter = {
          from_date: returnToday(-7),
          to_date: returnToday(-1),
        };
        this.getOrderList();
      } else if (val == 2) {
        this.orderFilter = {
          from_date: returnToday(1),
          to_date: returnToday(7),
        };
        this.getOrderList();
      }
    },
  },
  computed: {
    tableHeader() {
      if (this.$helper.isCompanyHasItems()) {
        this.orderColumnDefs.splice(5, 0, {
          headerName: "Total Items",
          field: "total_items",
          cellClass: "text-capitalize",
        });
      }
      return this.orderColumnDefs;
    },
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },
    totalPages() {
      return Math.ceil(this.totalCount / this.itemsPerPage);
    },
    context() {
      return { parentComponent: this };
    },
    profileObject() {
      let obj = localStorage.getItem("user_data");
      return obj ? JSON.parse(obj) : null;
    },
  },
  methods: {
    redirectCustomerDetails(customer) {
      if (customer && customer.id) {
        this.$router.push({
          name: "customer-details",
          params: {
            id: customer.id,
          },
        });
      }
    },
    autoSizeAll() {
      let allColumnIds = [];
      this.gridOptions.columnApi.getAllColumns().forEach(function (column) {
        allColumnIds.push(column.colId);
      });
      this.gridOptions.columnApi.autoSizeColumns(allColumnIds);
    },
    getCustomerAddressMapDetails() {
      bus.$emit("showLoader", true);
      this.$api.customerAddress
        .getCustomerAddressMapDetails(this.$route.params.id)
        .then((res) => {
          this.customerDetailsMapInfo = res.data;
          this.customerDetailsMapInfo.icon = "customer";

          const interval = setInterval(async () => {
            if (
              window.google &&
              window.google.maps &&
              this.$refs.customerLocation &&
              this.$refs.customerLocation.map
            ) {
              clearInterval(interval);
              this.$refs.customerLocation.removeAllMarkers();
              this.$refs.customerLocation.initBounds();
              if (
                this.customerDetailsMapInfo &&
                this.customerDetailsMapInfo.coordinates &&
                this.customerDetailsMapInfo.coordinates.longitude &&
                this.customerDetailsMapInfo.coordinates.latitude
              ) {
                this.$refs.customerLocation.setCustomMaker({
                  icon: "customer",
                  ...this.customerDetailsMapInfo,
                  ...this.customerDetailsMapInfo.customer_details,
                });
              }
              if (
                this.customerDetailsMapInfo &&
                this.customerDetailsMapInfo.serviceable_area
              ) {
                this.$refs.customerLocation.clearGeoJson();
                this.$refs.customerLocation.addFeatures([
                  {
                    geometry: this.customerDetailsMapInfo.serviceable_area,
                    type: "Feature",
                  },
                ]);
              }
            }
          }, 100);
          setTimeout(() => {
            clearInterval(interval);
          }, 1000);

          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    addCustomerAddress() {
      this.isEditing = false;
      this.selectedCustomerAddressID = null;
      this.showCustomerAddressFormDialog = true;
    },
    editCustomerAddress(id) {
      this.isEditing = true;
      this.selectedCustomerAddressID = id;
      this.showCustomerAddressFormDialog = true;
    },
    getCustomerAddressMap(id) {
      this.openCustomerAddressMapDialog = true;
      let timer = setInterval(() => {
        if (this.$refs.CustomerAddressLocation) {
          clearInterval(timer);
          this.$refs.CustomerAddressLocation.getCustomerAddressMapDetails(id);
        }
      }, 100);
      setTimeout(() => {
        clearInterval(timer);
      }, 10000);
    },
    getCustomerAddressLogs(id) {
      bus.$emit("showLoader", true);
      let params = {
        customer: this.customerAddressDetails.customer,
        customer_address: this.customerAddressDetails.id,
      };
      this.$api.logs
        .getCustomerAddressLogs(params)
        .then((res) => {
          this.customerAddressLogs = res.data;
          this.showCustomerAddressLogs = true;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getOrderList() {
      let params = {
        offset: this.offset,
        ...this.orderFilter,
        limit: this.itemsPerPage,
        customer: this.customerAddressDetails.customer,
        customer_address: this.customerAddressDetails.id,
        segment: "sales",
      };

      if (this.search) {
        params.search = this.search;
      }

      bus.$emit("showLoader", true);
      this.$api.orderNew
        .getOrderList(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.orderList = res.data;
          this.totalCount = res.count;
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },

    itemsPerPageChange(value) {
      this.pageNo = 1;
      this.itemsPerPage = value;
      this.getOrderList();
    },
    nextPage() {
      this.pageNo++;
      this.getOrderList();
    },
    prevPage() {
      this.pageNo--;
      this.getOrderList();
    },
    gridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
    },
    onScroll() {
      this.scrollInvoked++;
    },
    onDriverLogsScroll(e) {
      let scroll =
        parseInt(e.target.scrollHeight) -
        parseInt(e.target.scrollTop + e.target.clientHeight);
      if (scroll < 4 && this.isDriverLogsScrollable) {
        this.isDriverLogsScrollable = false;
        this.getDriverLogs();
      }
    },
    getOrderDetail(id) {
      bus.$emit("showLoader", true);
      this.$api.orderNew
        .getOrderView(id)
        .then((res) => {
          this.orderDetail = res.data;
          this.isVisibleOrderDetails = true;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    checkSubscriptionLimit() {
      this.$api.company
        .checkSubscriptionLimit(this.profileObject.company, {
          module: "customeraddress",
        })
        .then(() => {
          this.isButtonDisabled = false;
          return true;
        })
        .catch((err) => {
          bus.$emit("showToastMessage", {
            message: err.data.non_field_errors[0],
            color: "error",
            timeout: 4000,
          });
          this.isButtonDisabled = true;
          this.buttonTooltip = err.data.non_field_errors[0];
          return false;
        });
    },
    getCustomerAddressDetails() {
      bus.$emit("showLoader", true);
      this.$api.customerAddress
        .getCustomerAddressView(this.$route.params.id)
        .then((res) => {
          this.customerAddressDetails = res.data;
          this.getCustomerAddressLogs();
          this.getCustomerAddressTagList();
          this.getOrderList();
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    getCustomerAddressLogs() {
      bus.$emit("showLoader", true);
      let params = {
        customer: this.customerAddressDetails.customer,
        customer_address: this.customerAddressDetails.id,
        limit: "all",
      };
      this.$api.logs
        .getCustomerAddressLogs(params)
        .then((res) => {
          this.customerLogs = res.data;
          this.openCustomerLogDialog = true;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    deleteCustomerAddressTag(id) {
      bus.$emit("showLoader", true);
      this.$api.customerAddressTags
        .deleteCustomerAddressTagsObject(id)
        .then(() => {
          this.getCustomerAddressTagList();
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getCustomerAddressTagList() {
      bus.$emit("showLoader", true);
      this.$api.customerAddressTags
        .getCustomerAddressTagsList({
          customer_address: this.customerAddressDetails.id,
          limit: "all",
        })
        .then((res) => {
          this.customerAddressTagList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getOrderLogs() {
      const params = {
        order: this.orderDetail.id,
        limit: "all",
      };
      this.$api.logs
        .getOrderLogs(params)
        .then((res) => {
          this.orderLogs = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getAllData() {
      this.getCustomerAddressDetails();
      this.getOrderList();
    },
  },
  mounted() {
    if ("id" in this.$route.params) {
      this.getCustomerAddressDetails();
      this.getCustomerAddressMapDetails();
      // this.getOrderList();
    }
  },
  created() {
    this.permissions = this.$permissions.getPermission("customer");
    this.checkSubscriptionLimit();
  },
};
</script>

<style scoped>
.order-list-height {
  height: calc(100vh - 630px);
}
.app-driver-font-tab {
  font-family: roboto;
  text-transform: capitalize;
  letter-spacing: 0.1px;
}
.main-customer-layout {
  height: 100%;
}
.main-customer-layout .column-grid {
  display: grid;
  grid-template-columns: 400px 1fr 400px;
  grid-column-gap: 8px;
  height: calc(100vh - 130px);
}
.main-customer-layout .column-grid .column-grid-content {
  display: grid;
  grid-template-rows: 100px 1fr;
  grid-column-gap: 8px;
  height: calc(100vh - 130px);
}
.card-vehicle-analytic-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 9px;
}
</style>
